/**
 * PlaceholderTag 노드 뷰 컴포넌트
 * @description 플레이스홀더를 카드 형태의 뱃지로 렌더링한다.
 */

import { NodeViewWrapper, type NodeViewProps } from "@tiptap/react";
import { cn } from "@/lib/utils";

/**
 * PlaceholderTag 뷰 컴포넌트
 *
 * @description
 * 텍스트 에디터 내에서 플레이스홀더를 카드 형태로 표시한다.
 * 화면 표시: "안녕하세요, [차주명] 님" / 저장값: "안녕하세요, #{DeliveryCarOwnerName} 님"
 */
export const PlaceholderTagView = ({ node, selected }: NodeViewProps) => {
  const attrs = node.attrs as {
    placeholder: string;
    label: string;
    color: string;
  };
  const { label, color } = attrs;

  return (
    <NodeViewWrapper
      as="span"
      className="inline-block align-baseline"
      contentEditable={false}
    >
      <span
        className={cn(
          "inline-flex items-center justify-center",
          "px-2 py-0.5 mx-0.5",
          "text-xs font-semibold text-white",
          "rounded cursor-default select-none",
          "transition-all duration-150",
          selected && "ring-2 ring-offset-1 ring-blue-500",
        )}
        style={{
          backgroundColor: color,
          verticalAlign: "baseline",
          lineHeight: "1.4",
        }}
        title={attrs.placeholder}
      >
        {label}
      </span>
    </NodeViewWrapper>
  );
};

export default PlaceholderTagView;
